import FormField from "./FormField";

const CheckboxGroup = ({
  label,
  namePrefix,
  options,
  selectedOptions,
  onChange,
  description,
  required,
}) => (
  <FormField label={label} required={required} description={description}>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 pt-2">
      {options.map(({ name, label }) => (
        <label key={name} className="flex items-center space-x-2">
          <input
            type="checkbox"
            name={`${namePrefix}.${name}`}
            checked={selectedOptions[name]}
            onChange={onChange}
            className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 focus:ring-offset-2 focus:ring-2"
          />
          <span className="text-sm text-gray-700">{label}</span>
        </label>
      ))}
    </div>
  </FormField>
);
export default CheckboxGroup;
